<template lang="html">
    <div class="article">
        <div class="banner-img">
        </div>
        <div class="container">
            <p>全医佳新闻资讯列表 / <span>内容详情</span></p>
            <div class="content">
                <h2>“互联网+医疗设备质量控制和管理高峰论坛”</h2>
                <p>为认真学习国家最新颁布的医疗器械质量管理的相关法律法规，深入探讨如何将医疗器械使用管理、质量控制及维修管理的各方面工作与互联网技术相结合，提升医疗设备管理效率及使用安全性，由中国医学装备协会及全医佳医疗设备服务平台联合举办的“互联网+医疗设备质量控制和管理高峰论坛”于2016年6月26日在江苏南京圆满召开。</p>
                <div>
                    <img src="https://static.qyjmed.com/webSite/news/company/3-1.jpg" alt="">
                </div>
                <p>本次“互联网+医疗设备质量控制和管理高峰论坛”的主题为“互联网+时代下医疗设备管理和质量控制的发展之路”，是在国内举办的将移动互联网技术与医学装备管理理论相融合的跨界交流高端盛会，来自学术界、产业界、医院管理者、售后服务界、维修工程师及监管监督部门的管理者、知名专家和学者等150余人汇聚一堂，共同打造产、学、研、用、监管的跨界交流平台。此次会议深入解析了行业发展政策与环境、探讨“互联网+”新形态下的设备管理发展趋势，分享与挖掘互联网创新产品、技术，加强产业链交流与合作，把握产业脉博，引领行业管理发展新方向，共同助力提高医院设备管理质量。</p>
                <div>
                    <img src="https://static.qyjmed.com/webSite/news/company/3-2.jpg" alt="">
                </div>
                <p>在此次高峰论坛上，与会的管理者、知名专家和学者们就“互联网技术在医院设备管理及质控中的应用”、“如何通过医疗设备信息化管理系统提升医院设备质控水平”、“一站式医疗设备服务平台对解决设备维修难题的意义”等议题进行了深入的研讨，在行业标准制定、传达科研信息等方面产生了许多极具创造性、前瞻性的成果。</p>
                <div>
                    <img src="https://static.qyjmed.com/webSite/news/company/3-3.jpg" alt="">
                </div>
                <p>在会上，中国医学装备协会理事长赵自林指出，医疗设备在临床检查治疗中占有重要地位，是保证医院医疗、研究、教学工作的必要条件。近几年，整个医学装备发展比较快。根据中国医学装备协会的数据追踪，2009年，我国医学装备市场规模大体上是1442亿，到2014年底是4200亿，年均增长率超过两位数。在发达国家，医学装备和药品的市场规模比例大体是1：1，在我国2014年，药品是13000多亿，装备是4200亿，大体为3.5：1，所以医学装备发展的空间非常大</p>
                <div>
                    <img src="https://static.qyjmed.com/webSite/news/company/3-4.jpg" alt="">
                </div>
                <p>这些医疗设备为医疗卫生事业健康发展提供了强大的物质基础和技术支撑，同时，也对医学学装备售后服务提出了极高的保障能力需求。医院对医疗设备的管理和维护要求越来越高，如何保证设备的正常运行，提高诊疗的准确率，减少医疗设备风险及故障的发生，是医院现代化管理的重要内容。然而，医院医疗器械设备售后维修与运行状况并不容乐观。很多医院都或多或少地存在医工流失严重、维修手段落后、疏于医疗器械的维护保养、管理制度陈旧等问题，直接影响到器械的使用和诊疗效果。另外新型高科技医疗器械不断涌现，计算机技术、微电子技术、精加工技术、智能化技术等各种新的科技手段都应用于医疗器械的设计开发中，这更加重了医院管理、维修医疗器械的难度。</p>
                <div>
                    <img src="https://static.qyjmed.com/webSite/news/company/3-5.jpg" alt="">
                </div>
                <p>国家食药监总局在2015年10月21日颁布的18号令《医疗器械使用监督管理办法》对医疗器械质量管理有着重大意义，办法中对医疗机构医学装备管理提出了更高的要求，对医疗器械使用单位在采购、验收、贮存、使用、维护等环节上进行了细化。医院在设备使用中需要尽快提升设备管理水平，确保设备质量安全。国家食药监总还将专门出台医疗器械售后服务规定，严格使用环节的质量监管。意味着我国医疗器械全过程监管所有的重要环节都有法可依。</p>
                <div>
                    <img src="https://static.qyjmed.com/webSite/news/company/3-6.jpg" alt="">
                </div>
                <p>我国目前有三万多家医院，设备配置总量不断增加，设备管理人员和维修人员人员数量不足，维修技术能力还有待提升。传统手工管理方式效率低下、查询困难、无法追溯管理、无法参与绩效考核，很难达到“科学高效、全面直观”的管理目标，更不利于质量控制管理。随着互联网技术与医学装备产业的融合与发展，需要各部门、环节各自定位、协同合作，对各环节数据进行交互专业化处理。通过信息化技术管理医院的设备势在必行。也急需专业的设备管理软件系统来帮助医院完善设备管理的短板。</p>
                <div>
                    <img src="https://static.qyjmed.com/webSite/news/company/3-7.jpg" alt="">
                </div>
                <p>今年3月，国务院办公厅在关于促进医药产业健康发展的指导意见（国办发〔2016〕11号）也明确提出，要推动建立医疗设备的通信协议、故障反馈、检测维护等环节的源代码开放制度，鼓励发展第三方专业维护保养、售后服务队伍。这些都为医学装备售后服务工作提供了政策支撑。</p>
                <p>因此中国医学装备协会下一步要做的几项工作</p>
                <p>一是协助政府相关部门做好医学装备售后服务相关政策的技术支撑工作。</p>
                <p>二是继续开展医学装备售后服务满意度调查工作。</p>
                <p>三是加强医学装备技术人员的培养，将开展第三方维修机构和医学装备工程技术人员的认证工作。</p>
                <p>四是编制医疗器械相关维修指南和设备质量控制的相关标准。</p>
                <p>南京市食品药品监督管理局的华文常务副局长从设备使用过程的质量事故方面强调了设备质量管理信息化的必要性。在医疗事故中，有17%左右是由于医疗器械的操作使用不当、维修保养不到位以及质量的问题造成的，而医疗器械的质量问题有80%以上都是在使用过程中发生的，所以在设备管理环节更强调要强调维护和质量管理。</p>
                <p>南京军区总院医工科主任刘铁军介绍了医院设备管理中的实际困难和三大痛点，“管理难、质控难和维修难”。医院日常管理环节薄弱，缺乏控制体系；部分设备长期闲置，利用率低；各职能部门缺乏必要的协调和沟通；资产管理制度不健全，缺乏有效的监督管理机制。尤其在与设备质量息息相关的质控环节，缺乏人员、检测设备、检测标准均严重缺乏，很难达到法规规定的质控要求，为设备运行中的安全造成了严重的隐患。而设备维修难更是长期困扰医院的难题。无论内修、厂家维修、第三方维修均难以有效解决这一顽疾。</p>
                <p>“医院有多少台设备在带病工作？每一台设备的使用信息明确吗？设备出现故障，如何在第一时间获取维修信息？” 这正是医院管理者一直悬而未决的难题，也直击医院在设备管理上遗留的深层痼疾。刘主任提到，通过互联网技术有望有效解决以上难题，通过条码、RFID（电子标签）、电子化档案可以从提升制度化、规范化、精细化管理水平；加强设备使用效率管理，规范维修、质控管理三个方面切实提高设备管理质量。通过互联网经济的平台化方式将第三方维修力量有效整合，有望打破维修行业垄断，提升服务质量。医院迫切期望能有相关的软件和互联网产品来帮助解决设备管理中的实际困难。</p>
                <p>《世界医疗器械》杂志的主编姜宗义教授提到设备管理中需变被动为主动，加大对大型贵重医疗设备、仪器的维护与保养力度，并通过互联网手段解决监督执行的过程化管理难题，可有效延长设备、仪器的使用寿命，提高医院的综合效益。</p>
                <p>同时在新的国家政策支持下，第三方维修公司迅速崛起。合理的竞争才能打破垄断,医院通过找寻保质保量的第三方维修,不仅能够享受到高效的服务，还能够降低设备维护的巨额支出，切实解决医疗费用虚高的民生问题。</p>
                <p>来自全医佳医疗设备服务平台的谢玉丹副总经理详细介绍了全医佳设备管理软件系统的主要功能。全医佳医院设备管理软件是集医院设备的申请、采购、出入库、维修、维护、折旧、固定资产管理、效益分析等全流程管理功能于一体的信息化管理软件。该系统针对每一台设备度身制定不同的质量控制流程，结合该设备的后台数据分析，推荐国家及获认证的第三方检测机构，为医院提供可靠而权威的质量控制服务。协助医院及时发现潜在的医疗设备隐患，从而保证医疗设备的稳定性、安全性和有效性。对医院设备申购计划、招投标、采购、运营、维修保养、淘汰报废等各个环节全程数字化管理，是医院设备管理软件的领先者。</p>
                <p>来自全医佳医疗设备服务平台的戴跃跃总经理则介绍了全医佳医疗设备服务平台，正是针对医院三大痛点、为解决医疗设备服务行业内相关难题而搭建的生态服务类电子商务平台，通过整合医疗设备服务业的信息资源，形成行业联盟达解决“维修难题”。同时，全医佳也已与原厂及第三方维修服务商达成友好合作伙伴关系，以此增强维修保障力量并提高行业公信力。相互联合，资源互补，以共享各自资源，实现比较优势，实现真正意义上的行业合作模式，逐步建立一套规范而完善的行业服务标准，进而推动我国医疗设备服务业的健康发展。</p>
                <p>会上国内影像设备龙头企业华润万东医疗装备股份有限公司与全医佳医疗设备服务平台达成战略协议，授予全医佳以华润万东特约售后服务中心资质。</p>
                <p>与会专家从各个不同的角度展开了热烈的讨论，并达成了共识。移动互联、物联网、大数据技术的发展与应用，为全生命周期的设备智能化管理提供了广阔的发展前景，也让医疗设备管理迎来了物联网大数据时代。近两年来，采用“智能终端+云平台”的互联网+模式的新信息化手段逐步应用于医疗设备管理领域，对提高设备管理水平和经济效益具有重要意义。</p>
                <p>1、医院设备信息化管理，有利于加强主动保养，加大预防性维修力度</p>
                <p>2、可通过对设备效益分析，减少盲目购买、重复浪费</p>
                <p>3、可通过维修数据分析，对常见故障帮助判断，提前预防，减少故障率</p>
                <p>4、打破信息不对称，为第三方维修商提供整合平台，信息、数据共享，形成集团效应。</p>
                <p>全医佳医疗设备服务平台正是其中的领先者，为医院设备管理提供了一站式服务平台和全套信息化解决方案，使高效的设备质量管理及维修服务成为可能欢迎和期望类似全医佳医疗设备服务平台的互联网企业参与医疗设备信息化管理的建设，为医院设备管理提供更有效武器。</p>
            </div>
        </div>
        <Foot></Foot>
    </div>
</template>

<script>
import Foot from '@/components/Footer.vue'
export default {
    name:'article1',
    components: {
        Foot
    }
}
</script>

<style lang="scss" scoped>
    .article{
        letter-spacing: 1px;
        background: #F6F8FA;
        color: #000;
        .banner-img{
            margin-top: $highlight-height;
            height: 140px;
            background: url("https://static.qyjmed.com/webSite/productService/document/bg.png") center;
        }
        .container{
            >p{
                font-size: 18px;
                line-height: 76px;
                span{
                    color: #4EAAFC;
                }
            }
            .content{
                min-height: 600px;
                background: white;
                padding: 0 70px 70px;
                margin-bottom: 30px;
                h2{
                    font-size: 22px;
                    text-align: center;
                    font-weight: 400;
                    padding:46px 0 20px;
                }
                p{
                    line-height: 40px;
                    text-indent: 2rem;
                }
                div{
                    text-align: center;
                    img{
                        width: 900px;
                        padding:10px 0;
                    }
                }
            }
        }
    }
</style>
